/*
  TLS fingerprints: add by hash, delete a mark, built-in list
  (POST, DELETE /api/tls-fingerprints, GET /api/tls-fingerprints/seed).
  Merged FIRST into TRANSLATION_MAPS in ./index.js. Keys are the English source.
*/

const ru = {
  "Add fingerprint": "Добавить отпечаток",
  "Mark a JA3 or JA4 fingerprint before it shows up in your traffic. JA3 is 32 hex characters; JA4 looks like t13d1517h2_8daaf6152771_b186095e22b6.": "Пометьте отпечаток JA3 или JA4 ещё до того, как он появится в трафике. JA3 — 32 шестнадцатеричных символа; JA4 выглядит так: t13d1517h2_8daaf6152771_b186095e22b6.",
  "Fingerprint hash": "Хеш отпечатка",
  "This is not a JA3 or JA4 fingerprint.": "Это не отпечаток JA3 или JA4.",
  "Classification": "Оценка",
  "Label": "Метка",
  "Notes": "Заметки",
  "Fingerprint added": "Отпечаток добавлен",
  "Could not add the fingerprint": "Не удалось добавить отпечаток",
  "Built-in fingerprint list": "Встроенный список отпечатков",
  "Classified out of the box, read only. Your marks are added on top of this list.": "Оценены изначально, только чтение. Ваши пометки добавляются поверх этого списка.",
  "Could not load the built-in list.": "Не удалось загрузить встроенный список.",
  "Loading…": "Загрузка…",
  "Built-in list": "Встроенный список",
  "Delete mark": "Удалить пометку",
  "Delete the mark of this fingerprint? It falls back to the built-in list or to unknown.": "Удалить пометку этого отпечатка? Он вернётся к оценке из встроенного списка или станет «неизвестным».",
  "Mark deleted": "Пометка удалена",
  "Could not delete the mark": "Не удалось удалить пометку",
};

const es = {
  "Add fingerprint": "Añadir huella",
  "Mark a JA3 or JA4 fingerprint before it shows up in your traffic. JA3 is 32 hex characters; JA4 looks like t13d1517h2_8daaf6152771_b186095e22b6.": "Marca una huella JA3 o JA4 antes de que aparezca en tu tráfico. JA3 son 32 caracteres hexadecimales; JA4 tiene este aspecto: t13d1517h2_8daaf6152771_b186095e22b6.",
  "Fingerprint hash": "Hash de la huella",
  "This is not a JA3 or JA4 fingerprint.": "No es una huella JA3 ni JA4.",
  "Classification": "Clasificación",
  "Label": "Etiqueta",
  "Notes": "Notas",
  "Fingerprint added": "Huella añadida",
  "Could not add the fingerprint": "No se pudo añadir la huella",
  "Built-in fingerprint list": "Lista integrada de huellas",
  "Classified out of the box, read only. Your marks are added on top of this list.": "Clasificadas de serie, solo lectura. Tus marcas se suman a esta lista.",
  "Could not load the built-in list.": "No se pudo cargar la lista integrada.",
  "Loading…": "Cargando…",
  "Built-in list": "Lista integrada",
  "Delete mark": "Borrar marca",
  "Delete the mark of this fingerprint? It falls back to the built-in list or to unknown.": "¿Borrar la marca de esta huella? Volverá a la lista integrada o a desconocida.",
  "Mark deleted": "Marca borrada",
  "Could not delete the mark": "No se pudo borrar la marca",
};

const pt = {
  "Add fingerprint": "Adicionar impressão",
  "Mark a JA3 or JA4 fingerprint before it shows up in your traffic. JA3 is 32 hex characters; JA4 looks like t13d1517h2_8daaf6152771_b186095e22b6.": "Marque uma impressão JA3 ou JA4 antes que ela apareça no seu tráfego. JA3 tem 32 caracteres hexadecimais; JA4 tem este formato: t13d1517h2_8daaf6152771_b186095e22b6.",
  "Fingerprint hash": "Hash da impressão",
  "This is not a JA3 or JA4 fingerprint.": "Isso não é uma impressão JA3 nem JA4.",
  "Classification": "Classificação",
  "Label": "Rótulo",
  "Notes": "Notas",
  "Fingerprint added": "Impressão adicionada",
  "Could not add the fingerprint": "Não foi possível adicionar a impressão",
  "Built-in fingerprint list": "Lista integrada de impressões",
  "Classified out of the box, read only. Your marks are added on top of this list.": "Classificadas de fábrica, somente leitura. Suas marcações são somadas a esta lista.",
  "Could not load the built-in list.": "Não foi possível carregar a lista integrada.",
  "Loading…": "Carregando…",
  "Built-in list": "Lista integrada",
  "Delete mark": "Excluir marcação",
  "Delete the mark of this fingerprint? It falls back to the built-in list or to unknown.": "Excluir a marcação desta impressão? Ela volta para a lista integrada ou fica desconhecida.",
  "Mark deleted": "Marcação excluída",
  "Could not delete the mark": "Não foi possível excluir a marcação",
};

const de = {
  "Add fingerprint": "Fingerprint hinzufügen",
  "Mark a JA3 or JA4 fingerprint before it shows up in your traffic. JA3 is 32 hex characters; JA4 looks like t13d1517h2_8daaf6152771_b186095e22b6.": "Markiere einen JA3- oder JA4-Fingerprint, bevor er in deinem Traffic auftaucht. JA3 sind 32 Hex-Zeichen; JA4 sieht so aus: t13d1517h2_8daaf6152771_b186095e22b6.",
  "Fingerprint hash": "Fingerprint-Hash",
  "This is not a JA3 or JA4 fingerprint.": "Das ist kein JA3- oder JA4-Fingerprint.",
  "Classification": "Einstufung",
  "Label": "Bezeichnung",
  "Notes": "Notizen",
  "Fingerprint added": "Fingerprint hinzugefügt",
  "Could not add the fingerprint": "Der Fingerprint konnte nicht hinzugefügt werden",
  "Built-in fingerprint list": "Integrierte Fingerprint-Liste",
  "Classified out of the box, read only. Your marks are added on top of this list.": "Ab Werk eingestuft, nur lesbar. Deine Markierungen kommen zu dieser Liste hinzu.",
  "Could not load the built-in list.": "Die integrierte Liste konnte nicht geladen werden.",
  "Loading…": "Wird geladen…",
  "Built-in list": "Integrierte Liste",
  "Delete mark": "Markierung löschen",
  "Delete the mark of this fingerprint? It falls back to the built-in list or to unknown.": "Markierung dieses Fingerprints löschen? Er fällt auf die integrierte Liste oder auf unbekannt zurück.",
  "Mark deleted": "Markierung gelöscht",
  "Could not delete the mark": "Die Markierung konnte nicht gelöscht werden",
};

const fr = {
  "Add fingerprint": "Ajouter une empreinte",
  "Mark a JA3 or JA4 fingerprint before it shows up in your traffic. JA3 is 32 hex characters; JA4 looks like t13d1517h2_8daaf6152771_b186095e22b6.": "Marquez une empreinte JA3 ou JA4 avant qu’elle n’apparaisse dans votre trafic. JA3 fait 32 caractères hexadécimaux ; JA4 ressemble à t13d1517h2_8daaf6152771_b186095e22b6.",
  "Fingerprint hash": "Hash de l’empreinte",
  "This is not a JA3 or JA4 fingerprint.": "Ce n’est pas une empreinte JA3 ou JA4.",
  "Classification": "Classification",
  "Label": "Libellé",
  "Notes": "Notes",
  "Fingerprint added": "Empreinte ajoutée",
  "Could not add the fingerprint": "Impossible d’ajouter l’empreinte",
  "Built-in fingerprint list": "Liste d’empreintes intégrée",
  "Classified out of the box, read only. Your marks are added on top of this list.": "Classées d’origine, en lecture seule. Vos marques s’ajoutent à cette liste.",
  "Could not load the built-in list.": "Impossible de charger la liste intégrée.",
  "Loading…": "Chargement…",
  "Built-in list": "Liste intégrée",
  "Delete mark": "Supprimer la marque",
  "Delete the mark of this fingerprint? It falls back to the built-in list or to unknown.": "Supprimer la marque de cette empreinte ? Elle revient à la liste intégrée ou à inconnue.",
  "Mark deleted": "Marque supprimée",
  "Could not delete the mark": "Impossible de supprimer la marque",
};

const it = {
  "Add fingerprint": "Aggiungi fingerprint",
  "Mark a JA3 or JA4 fingerprint before it shows up in your traffic. JA3 is 32 hex characters; JA4 looks like t13d1517h2_8daaf6152771_b186095e22b6.": "Segna un fingerprint JA3 o JA4 prima che compaia nel tuo traffico. JA3 è di 32 caratteri esadecimali; JA4 ha questa forma: t13d1517h2_8daaf6152771_b186095e22b6.",
  "Fingerprint hash": "Hash del fingerprint",
  "This is not a JA3 or JA4 fingerprint.": "Non è un fingerprint JA3 o JA4.",
  "Classification": "Classificazione",
  "Label": "Etichetta",
  "Notes": "Note",
  "Fingerprint added": "Fingerprint aggiunto",
  "Could not add the fingerprint": "Impossibile aggiungere il fingerprint",
  "Built-in fingerprint list": "Elenco integrato di fingerprint",
  "Classified out of the box, read only. Your marks are added on top of this list.": "Classificati di serie, sola lettura. I tuoi segni si aggiungono a questo elenco.",
  "Could not load the built-in list.": "Impossibile caricare l’elenco integrato.",
  "Loading…": "Caricamento…",
  "Built-in list": "Elenco integrato",
  "Delete mark": "Elimina segno",
  "Delete the mark of this fingerprint? It falls back to the built-in list or to unknown.": "Eliminare il segno di questo fingerprint? Torna all’elenco integrato o a sconosciuto.",
  "Mark deleted": "Segno eliminato",
  "Could not delete the mark": "Impossibile eliminare il segno",
};

const pl = {
  "Add fingerprint": "Dodaj odcisk",
  "Mark a JA3 or JA4 fingerprint before it shows up in your traffic. JA3 is 32 hex characters; JA4 looks like t13d1517h2_8daaf6152771_b186095e22b6.": "Oznacz odcisk JA3 lub JA4, zanim pojawi się w ruchu. JA3 to 32 znaki szesnastkowe; JA4 wygląda tak: t13d1517h2_8daaf6152771_b186095e22b6.",
  "Fingerprint hash": "Hash odcisku",
  "This is not a JA3 or JA4 fingerprint.": "To nie jest odcisk JA3 ani JA4.",
  "Classification": "Klasyfikacja",
  "Label": "Etykieta",
  "Notes": "Notatki",
  "Fingerprint added": "Odcisk dodany",
  "Could not add the fingerprint": "Nie udało się dodać odcisku",
  "Built-in fingerprint list": "Wbudowana lista odcisków",
  "Classified out of the box, read only. Your marks are added on top of this list.": "Sklasyfikowane fabrycznie, tylko do odczytu. Twoje oznaczenia są dodawane do tej listy.",
  "Could not load the built-in list.": "Nie udało się wczytać wbudowanej listy.",
  "Loading…": "Wczytywanie…",
  "Built-in list": "Lista wbudowana",
  "Delete mark": "Usuń oznaczenie",
  "Delete the mark of this fingerprint? It falls back to the built-in list or to unknown.": "Usunąć oznaczenie tego odcisku? Wróci do listy wbudowanej albo do nieznanych.",
  "Mark deleted": "Oznaczenie usunięte",
  "Could not delete the mark": "Nie udało się usunąć oznaczenia",
};

const tr = {
  "Add fingerprint": "Parmak izi ekle",
  "Mark a JA3 or JA4 fingerprint before it shows up in your traffic. JA3 is 32 hex characters; JA4 looks like t13d1517h2_8daaf6152771_b186095e22b6.": "Bir JA3 veya JA4 parmak izini trafiğinizde görünmeden önce işaretleyin. JA3 32 onaltılık karakterdir; JA4 şöyle görünür: t13d1517h2_8daaf6152771_b186095e22b6.",
  "Fingerprint hash": "Parmak izi hash’i",
  "This is not a JA3 or JA4 fingerprint.": "Bu bir JA3 veya JA4 parmak izi değil.",
  "Classification": "Sınıflandırma",
  "Label": "Etiket",
  "Notes": "Notlar",
  "Fingerprint added": "Parmak izi eklendi",
  "Could not add the fingerprint": "Parmak izi eklenemedi",
  "Built-in fingerprint list": "Yerleşik parmak izi listesi",
  "Classified out of the box, read only. Your marks are added on top of this list.": "Hazır sınıflandırılmış, salt okunur. İşaretleriniz bu listeye eklenir.",
  "Could not load the built-in list.": "Yerleşik liste yüklenemedi.",
  "Loading…": "Yükleniyor…",
  "Built-in list": "Yerleşik liste",
  "Delete mark": "İşareti sil",
  "Delete the mark of this fingerprint? It falls back to the built-in list or to unknown.": "Bu parmak izinin işareti silinsin mi? Yerleşik listeye veya bilinmeyene döner.",
  "Mark deleted": "İşaret silindi",
  "Could not delete the mark": "İşaret silinemedi",
};

const uk = {
  "Add fingerprint": "Додати відбиток",
  "Mark a JA3 or JA4 fingerprint before it shows up in your traffic. JA3 is 32 hex characters; JA4 looks like t13d1517h2_8daaf6152771_b186095e22b6.": "Позначте відбиток JA3 або JA4 ще до того, як він зʼявиться в трафіку. JA3 — 32 шістнадцяткові символи; JA4 виглядає так: t13d1517h2_8daaf6152771_b186095e22b6.",
  "Fingerprint hash": "Хеш відбитка",
  "This is not a JA3 or JA4 fingerprint.": "Це не відбиток JA3 чи JA4.",
  "Classification": "Оцінка",
  "Label": "Мітка",
  "Notes": "Нотатки",
  "Fingerprint added": "Відбиток додано",
  "Could not add the fingerprint": "Не вдалося додати відбиток",
  "Built-in fingerprint list": "Вбудований список відбитків",
  "Classified out of the box, read only. Your marks are added on top of this list.": "Оцінені від початку, лише читання. Ваші позначки додаються поверх цього списку.",
  "Could not load the built-in list.": "Не вдалося завантажити вбудований список.",
  "Loading…": "Завантаження…",
  "Built-in list": "Вбудований список",
  "Delete mark": "Видалити позначку",
  "Delete the mark of this fingerprint? It falls back to the built-in list or to unknown.": "Видалити позначку цього відбитка? Він повернеться до оцінки з вбудованого списку або стане «невідомим».",
  "Mark deleted": "Позначку видалено",
  "Could not delete the mark": "Не вдалося видалити позначку",
};

const TLS_TOOLS = { ru, es, pt, de, fr, it, pl, tr, uk };
export default TLS_TOOLS;
